// Vendor libraries
import { createAction, props } from '@ngrx/store';

// Interfaces
import {
    ComplianceDesignationTypeOptions,
    ComplianceReportTypeOptions,
} from 'FoldersApp/apps/compliance-report-history-app/interfaces/compliance-report-type-options.interface';

export const setComplianceReportHistoryFilters = createAction(
    '[Compliance Report History Page] Apply Filters',
    props<{
        reportType: ComplianceReportTypeOptions;
        designationType: ComplianceDesignationTypeOptions;
        startDate: string | null;
        endDate: string | null;
    }>()
);
